import { render, staticRenderFns } from "./IconShareSolid.vue?vue&type=template&id=6f5efa24"
import script from "./IconShareSolid.vue?vue&type=script&lang=js"
export * from "./IconShareSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports